import { packages } from '@shared/api/services'
import { useQuery } from '@tanstack/react-query'

export const useProfilePackages = () => {
	return useQuery({
		queryKey: ['profile-packages'],
		queryFn: () => packages.getProfilePackages(),
		select: (data) => data.data,
	})
}
